export const categoryStatusEnum = {
    0: 'Editing',
    1: 'Published'
};

export const categoriesTreesEnum = {
    'shop': 1,
    'WFMAG': 2,
    'ceneo': 3
};